import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <header className="header-hdt">
      <div className="container-hdt">
        <div className="content-hdt">
          <div className="left-hdt">
            <div className="tagline-hdt">
              <span className="tagline-icon-hdt">✈</span>
              <span className="tagline-text-hdt">USA - LOME</span>
              <span className="tagline-line-hdt"></span>
            </div>

            <h1 className="title-hdt">
              Explorez les <br />
              Produits USA <br />
              Au Togo
            </h1>

            <p className="description-hdt">
            L’Amérique dans votre panier : découvrez des produits authentiques importés
            directement des États-Unis, disponibles maintenant au Togo.
            </p>

            <div className="searchbar-hdt">
              <div className="search-item-hdt">
                <div className="search-icon-hdt">📍</div>
                <div>
                  <h4 className="search-title-hdt">TOGO - LOME</h4>
                  
                </div>
              </div>

              


              <button className="cta-btn-hdt">Tel: +228 90 04 59 26</button>
            </div>
          </div>

          <div className="right-hdt">
            <div className="card-stack-hdt">
              <div className="card-hdt card-top-center-hdt">
                <img
                  src="/images/about1.webp"
                  alt="Balloon destination"
                />
              </div>

              {/* <div className="badge-hdt badge-destination-hdt">
                <h4>100+ Destinations</h4>
                <p>More than 100 Travelers use this platform</p>
              </div> */}

              <div className="card-hdt card-top-right-hdt">
                <img
                  src="/images/about2.webp"
                  alt="Tropical resort"
                />
              </div>

              {/* <div className="badge-hdt badge-verified-hdt">
                <h4>100%</h4>
                <p>Verified</p>
              </div> */}

              <div className="card-hdt card-bottom-left-hdt">
                <img
                  src="/images/d1.webp"
                  alt="Beach villa"
                />
              </div>

              <div className="card-hdt card-bottom-right-hdt">
                <img
                  src="/images/d2.webp"
                  alt="Mountain traveler"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;